import type { StrapiLocale } from '@nuxtjs/strapi/dist/runtime/types'
import type { StrapiHowto } from '~~/types/strapi'

export async function useHowtoPage() {
  const route = useRoute()
  const i18n = useI18n()
  const strapi = useStrapi()

  const params = computed(() => ({
    locale: i18n.locale.value as StrapiLocale,
    slug: route.params.slug as string,
  }))

  const { data: pageData } = await useAsyncData(
    `how-to:${JSON.stringify(params.value)}`,
    () =>
      strapi.find<StrapiHowto>('how-tos', {
        locale: params.value.locale,
        filters: {
          slug: params.value.slug,
        },
        populate: {
          image: {
            fields: ['url'],
          },
          dynamicContent: {
            on: {
              'dynamic-content.content': {
                populate: '*',
              },
              'dynamic-content.step-group': {
                populate: '*',
              },
            },
          },
          seo: {
            populate: '*',
          },
        },
      })
    /*  {
      watch: [params],
      immediate: true,
      deep: true,
    } */
  )

  if (!pageData?.value?.data[0]) {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
  }

  return {
    pageData: computed(() => pageData.value?.data[0]!),
  }
}

export async function useHowtoEntriesPage() {
  const route = useRoute()
  const i18n = useI18n()
  const strapi = useStrapi()

  const params = computed(() => ({
    locale: i18n.locale.value as StrapiLocale,
    page: Number(route.query.page) || 1,
    pageSize: Number(route.query.pageSize) || 100,
  }))

  const { data } = await useAsyncData(
    `how-tos:${JSON.stringify(params.value)}`,
    () =>
      strapi.find<StrapiHowto>('how-tos', {
        locale: params.value.locale,
        populate: {
          image: {
            fields: ['url'],
          },
        },
        pagination: {
          page: Number(params.value.page),
          pageSize: Number(params.value.pageSize),
        },
        sort: ['date:desc', 'updatedAt:desc', 'createdAt:desc'],
      })
  )
  return {
    data: computed(() => data?.value?.data || []),
    meta: computed(() => data?.value?.meta || {}),
  }
}
